import {useState} from 'react';
import {I18n} from 'aws-amplify/utils';
import {FlexiAddButton} from '@flexinet/ui-components';

import {AddFormDrawer} from '../drawers/AddFormDrawer';
import {useZoneCreateConnections} from '../hooks/useZoneCreateConnections';

// FNP-1191 CRUD half — the Add button, per the drawer pattern.
//
// ⚠️ HIDDEN, NOT DISABLED, WHEN NOTHING CAN CREATE A ZONE.
//
// The read half stated the rule and left the slot: "an Add Zone button belongs
// here, rendered only when canCreateZones is true... a disabled Add button
// would promise a capability the schema cannot serve today." This is that
// button, and it keeps the direction of the default.
//
// The gate here is `useZoneCreateConnections`, NOT `useZoneWriteCapabilities`,
// and the difference matters. `useZoneWriteCapabilities` answers "can THIS
// connection write" — the right question on a detail page, where a zone names
// its connection. The index page has no single connection: zones fan out across
// all of them. The right question there is "is there ANY connection I could
// create a zone through", which is what this hook answers, applying the same
// two tests (ACTIVE status AND canCreateZones) per connection.
//
// ⚠️ THE DEFAULT SURVIVES: the hook returns an empty list while loading and on
// error, so the button is absent in every unknown case. An absent button is a
// correct statement about a read-only tenant; one that appears and then fails
// at submit tells them their credential is broken when the truth is that Flexi
// should never have offered the action.
//
// ⚠️ USES THE SHARED FlexiAddButton, not a local Button. A private add button
// that also exists in @flexinet/ui-components is drift, not an override.

export const AddRecordButton = () => {

    const [drawerOpened, setDrawerOpened] = useState(false);
    const {connections} = useZoneCreateConnections();

    // No writable connection — and no loading state to distinguish, because
    // both hide. Rendering nothing is the whole decision.
    if (connections.length === 0) {
        return null;
    }

    if (drawerOpened) {
        return (
            <AddFormDrawer
                opened={drawerOpened}
                onClose={() => setDrawerOpened(false)}
            />
        );
    }

    return (
        <FlexiAddButton onClick={() => setDrawerOpened(true)}>
            {I18n.get('Add Zone')}
        </FlexiAddButton>
    );
};
